import {createAction} from "@reduxjs/toolkit";

import {
  DONE,
  FAIL,
  GET,
  FETCH,
  JOURNAL,
  TABLE,
  LESSON,
  ADD,
  MARK,
  POST,
  EDIT, TABS,
  SET,LESSON_ID, ITEM, ACCOUNTING, EXPORT, LOG,
  DATA, LIST, CURRENT, INDIVIDUAL, COLUMN, PERFORMANCE, SDOT, RESULT, TASK, TYPES, TEST, STUDENT, CTP, FILTER, RESET, INNER, VIEW
} from "../../constants";
import {IJournalTable} from "./types";

export const getJournalListAction = createAction<undefined>(GET + JOURNAL + LIST + FETCH);
export const getJournalListActionDone = createAction<any>(GET + JOURNAL + LIST + FETCH + DONE);
export const getJournalListActionFail = createAction<undefined>(GET + JOURNAL + LIST + FETCH + FAIL);

export const getJournalCurrentCtpListAction = createAction<any>(GET + JOURNAL + CURRENT + CTP + LIST + FETCH);
export const getJournalCurrentCtpListActionDone = createAction<any>(GET + JOURNAL + CURRENT + CTP + LIST + FETCH + DONE);
export const getJournalCurrentCtpListActionFail = createAction<any>(GET + JOURNAL + CURRENT + CTP + LIST + FETCH + FAIL);

export const getJournalCurrentFilterAction = createAction<any>(GET + JOURNAL + CURRENT + FILTER + FETCH);
export const getJournalCurrentFilterActionDone = createAction<any>(GET + JOURNAL + CURRENT + FILTER + FETCH + DONE);
export const getJournalCurrentFilterActionFail = createAction<undefined>(GET + JOURNAL + CURRENT + FILTER + FETCH + FAIL);

export const getJournalCurrentAction = createAction<IJournalTable>(GET + JOURNAL + CURRENT + FETCH);
export const getJournalCurrentActionDone = createAction<IJournalTable>(GET + JOURNAL + CURRENT + FETCH + DONE);
export const getJournalCurrentActionFail = createAction<IJournalTable>(GET + JOURNAL + CURRENT + FETCH + FAIL);

export const getJournalTableAction = createAction<IJournalTable>(GET + JOURNAL + TABLE + FETCH);
export const getJournalTableActionDone = createAction<IJournalTable>(GET + JOURNAL + TABLE + FETCH + DONE);
export const getJournalTableActionFail = createAction<IJournalTable>(GET + JOURNAL + TABLE + FETCH + FAIL);

export const postJournalLessonAction = createAction<undefined>(POST + JOURNAL + LESSON + ADD);
export const postJournalLessonActionDone = createAction<undefined>(POST + JOURNAL + LESSON + ADD + DONE);
export const postJournalLessonActionFail = createAction<undefined>(POST + JOURNAL + LESSON + ADD + FAIL);

export const getGetPerformance = createAction<any>(GET + PERFORMANCE + FETCH);
export const getGetPerformanceDone = createAction<any>(GET + PERFORMANCE + FETCH + DONE);
export const getGetPerformanceFail = createAction<undefined>(GET + PERFORMANCE + FETCH + FAIL);

export const getGetStudentPerformance = createAction<undefined>(GET + STUDENT + PERFORMANCE + FETCH);
export const getGetStudentPerformanceDone = createAction<any>(GET + STUDENT + PERFORMANCE + FETCH + DONE);
export const getGetStudentPerformanceFail = createAction<undefined>(GET + STUDENT + PERFORMANCE + FETCH + FAIL);

export const getGetSdotByMark = createAction<any>(GET + SDOT + MARK + FETCH);
export const getGetSdotByMarkDone = createAction<any>(GET + SDOT + MARK + FETCH + DONE);
export const getGetSdotByMarkFail = createAction<undefined>(GET + SDOT + MARK + FETCH + FAIL);

export const getGetSdotByMarkCurrent = createAction<any>(GET + SDOT + MARK + CURRENT + FETCH);
export const getGetSdotByMarkCurrentDone = createAction<any>(GET + SDOT + MARK + CURRENT + FETCH + DONE);
export const getGetSdotByMarkCurrentFail = createAction<undefined>(GET + SDOT + MARK + CURRENT + FETCH + FAIL);

export const setRateTaskResult = createAction<any>(SET + TASK + RESULT + CURRENT + FETCH);
export const setRateTaskResultDone = createAction<any>(SET + TASK + RESULT + CURRENT + FETCH + DONE);
export const setRateTaskResultFail = createAction<undefined>(SET + TASK + RESULT + CURRENT + FETCH + FAIL);

export const setMarkSdotType = createAction<any>(SET + MARK + SDOT + TYPES + FETCH);
export const setMarkSdotTypeDone = createAction<any>(SET + MARK + SDOT + TYPES + FETCH + DONE);
export const setMarkSdotTypeFail = createAction<undefined>(SET + MARK + SDOT + TYPES + FETCH + FAIL);

export const setTestResultByStudent = createAction<any>(GET + TEST + RESULT + STUDENT + FETCH);
export const setTestResultByStudentDone = createAction<any>(GET + TEST + RESULT + STUDENT + FETCH + DONE);
export const setTestResultByStudentFail = createAction<undefined>(GET + TEST + RESULT + STUDENT + FETCH + FAIL);

export const getJournalTableInnerView = createAction<any>(GET + JOURNAL + TABLE + INNER + VIEW + FETCH);
export const getJournalTableInnerViewDone = createAction<any>(GET + JOURNAL + TABLE + INNER + VIEW + FETCH + DONE);
export const getJournalTableInnerViewFail = createAction<undefined>(GET + JOURNAL + TABLE + INNER + VIEW + FETCH + FAIL);

export const journalTableExport = createAction<any>(GET + JOURNAL + TABLE + EXPORT + FETCH);
export const journalTableExportDone = createAction<any>(GET + JOURNAL + TABLE + EXPORT + FETCH + DONE);
export const journalTableExportFail = createAction<undefined>(GET + JOURNAL + TABLE + EXPORT + FETCH + FAIL);

export const journalTableLog = createAction<any>(GET + JOURNAL + LOG + EXPORT + FETCH);
export const journalTableLogDone = createAction<any>(GET + JOURNAL + LOG + EXPORT + FETCH + DONE);
export const journalTableLogFail = createAction<undefined>(GET + JOURNAL + LOG + EXPORT + FETCH + FAIL);

export const resetJournal = createAction<undefined>(RESET + JOURNAL);
